import {
    EDisplayStatus,
    EDisplayType,
    IScreen,
    IScreenDto,
} from '@app/interfaces/screen.interface';
import { GenericModel } from '@app/models/generic.model';

export class ScreenModel extends GenericModel<IScreen, IScreenDto> implements IScreen {
    deviceId: string;
    serial_number: string;
    error?: { type: 'ELEVEIGHT' | 'KONE' | 'MEDUSA'; message: string };
    ken?: string;
    functionalLocation?: string;
    edaVersion?: string;
    eloVersion?: string;
    androidBrand?: string;
    language?: string;
    cop?: string;
    copPosition?: string;
    linked: boolean;
    model?: string;
    location?: string;
    orientation?: string;
    networkType?: string;
    cmsUrl?: string;
    screenSize: number;
    name?: string;
    displayType: EDisplayType;
    venueId?: string;
    status?: EDisplayStatus;
    lastSeenAt?: string;
    contentSummary?: string;
    visionEnabled?: boolean;
    referenceUrl?: string;
    operatingSystem?: string;
    macAddress?: string;
    iccid?: string;
    firmwareVersion?: string;
    connectivityMethod?: string;
    cameraType?: string;
    resolution?: string;
    locationDetail?: string;
    contentAreaWidth?: number;
    contentAreaHeight?: number;

    contractStartDate?: string;
    contractEndDate?: string;
    activeContract: boolean;
    active?: boolean;
    shadowKen: boolean;

    constructor(
        dto: IScreenDto,
        shadowKen: boolean,
        activeContract: boolean,
        contractEndDate?: string,
        contractStartDate?: string,
    ) {
        super(dto);

        this.deviceId = dto.device_id;
        this.serial_number = dto.serial_number;
        this.error = dto.error;
        this.ken = dto.ken;
        this.functionalLocation = dto.functional_location;
        this.edaVersion = dto.eda_version;
        this.eloVersion = dto.elo_version;
        this.androidBrand = dto.android_brand;
        this.language = dto.language;
        this.cop = dto.cop;
        this.copPosition = dto.cop_position;
        this.linked = dto.linked;
        this.model = dto.eleveight.model;
        this.location = dto.eleveight.advertising_attributes.location;
        this.orientation = dto.eleveight.advertising_attributes.orientation;
        this.networkType = dto.eleveight.custom_attributes.connectivity_method;
        this.cmsUrl = dto.eleveight.url;
        this.screenSize = dto.eleveight.advertising_attributes.screen_size;
        this.name = dto.eleveight.name;
        this.displayType = dto.displayType;
        this.venueId = dto.eleveight.venue_id;
        this.status = dto.eleveight.status;
        this.lastSeenAt = dto.eleveight.last_seen_at;
        this.contentSummary = dto.eleveight.content_summary;
        this.visionEnabled = dto.eleveight.custom_attributes.vision_enabled ?? undefined;
        this.referenceUrl = dto.eleveight.custom_attributes.reference_url;
        this.operatingSystem = dto.eleveight.custom_attributes.operating_system;
        this.macAddress = dto.eleveight.custom_attributes.mac_address;
        this.iccid = dto.eleveight.custom_attributes.iccid;
        this.firmwareVersion = dto.eleveight.custom_attributes.firmware_version;
        this.connectivityMethod = dto.eleveight.custom_attributes.connectivity_method;
        this.cameraType = dto.eleveight.custom_attributes.camera_type;
        this.resolution = dto.eleveight.advertising_attributes.resolution;
        this.locationDetail = dto.eleveight.advertising_attributes.location_detail;
        this.contentAreaWidth =
            dto.eleveight.advertising_attributes.content_area_width ?? undefined;
        this.contentAreaHeight =
            dto.eleveight.advertising_attributes.content_area_height ?? undefined;
        this.active = dto.active;
        this.shadowKen = shadowKen;
        this.contractEndDate = contractEndDate;
        this.activeContract = activeContract;
        this.contractStartDate = contractStartDate;
    }

    dataTransferObject(): Partial<IScreenDto> {
        return {
            device_id: this.deviceId,
            serial_number: this.serial_number,
            ken: this.ken,
            eda_version: this.edaVersion,
            elo_version: this.eloVersion,
            android_brand: this.androidBrand,
            language: this.language,
            cop: this.cop,
            displayType: this.displayType,
            eleveight: {
                venue_id: this.venueId,
                name: this.name,
                model: this.model,
                content_summary: this.contentSummary,
                custom_attributes: {
                    connectivity_method: this.connectivityMethod,
                    vision_enabled: this.visionEnabled,
                    camera_type: this.cameraType,
                    mac_address: this.macAddress,
                    iccid: this.iccid,
                    firmware_version: this.firmwareVersion,
                    operating_system: this.operatingSystem,
                    reference_url: this.referenceUrl,
                },
                advertising_attributes: {
                    location: this.location,
                    location_detail: this.locationDetail,
                    screen_size: this.screenSize,
                    resolution: this.resolution,
                    content_area_height: this.contentAreaHeight,
                    content_area_width: this.contentAreaWidth,
                    orientation: this.orientation,
                },
            },
        };
    }
}
